import { apiRequestGet, apiRequestPost, apiRequestDelete } from 'mastodon/api';

import type {
  ApiShortcutJSON,
  ApiCreateShortcutPayload,
} from '../api_types/shortcuts';

export const apiGetShortcuts = () =>
  apiRequestGet<ApiShortcutJSON[]>('v1/shortcuts');

export const apiCreateShortcut = (payload: ApiCreateShortcutPayload) =>
  apiRequestPost<ApiShortcutJSON>('v1/shortcuts', payload);

export const apiDeleteShortcut = (id: string) =>
  apiRequestDelete(`v1/shortcuts/${id}`);
